<div class="collapsible primary-bg-color" [ngClass]="{ 'expanded': !collapsed }">
  <p *ngIf="!collapsed" [@expanded] class="offer-description" (@expanded.done)="onAnimationDone()" id="sms-modal-offer-description" tabindex="-1">{{description}}</p>

  <button class="description-toggle" (click)="collapsed = !collapsed" [attr.aria-expanded]="!collapsed">
    <span>{{translateService.instant('component.sms_sub_promo_modal.offer_details')}} &nbsp;</span>
    <img [src]="'assets/img/chevron-down.svg' | deployUrl" alt="Learn more icon" aria-hidden="true">
  </button>
</div>
